import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../shared';

/**
 * Profile API - Base definition
 *
 * This is the base API slice for the Profile service.
 * Endpoints are split into separate files and injected using injectEndpoints.
 *
 * @see profileEndpoints.ts - Profile CRUD and management
 * @see accessEndpoints.ts - Center and claim access management
 */
export const profileApi = createApi({
  reducerPath: 'profileApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.profile),
  tagTypes: ['myProfile', 'roles', 'claims', 'profileLookup', 'userProfile', 'jobTitles', 'userSearch', 'PortalUsers', 'vobAssignments'],
  endpoints: () => ({}),
});
